// extracted by mini-css-extract-plugin
export default {"avatar":"DOAXxKsxzb4ibgrpABAP","avatars":"g3K8xrgU4vN5ZN0eA_GI"};